export default {
  placeholder: 'Wybierz grupę gatunków stali',
};
